import { get, put } from '@/utils/request'

export function getMenus(params) {
	return get('api/epanel/account/menus/', params)
}

export function updateMenu(id, data) {
    return put('api/epanel/account/menus/' + id + '/', data)
}
